/** Animate background from previous position to new position */
export const transitionBackground = (prevDisplayValue, displayValue, valueContainer) => {
  // I'm pretty sure we do need the fillmode each statement/time to be 'forwards' sorry so the background position stays where the animation ends.
  // Animation names match with animations setup in _community-graph.scss.
  // from top
  if (prevDisplayValue == 100 && displayValue >= 60 && displayValue < 99) {
    valueContainer.style.animation = 'top-upper-range-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue == 100 && displayValue > 39 && displayValue < 59) {
    valueContainer.style.animation = 'top-mid-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue == 100 && displayValue > 0 && displayValue < 39) {
    valueContainer.style.animation = 'top-lower-range-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue == 100 && displayValue == 0) {
    valueContainer.style.animation = 'top-bottom-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  }
  // from upper range
  else if (prevDisplayValue >= 60 && prevDisplayValue < 99 && displayValue == 100) {
    valueContainer.style.animation = 'top-upper-range-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue >= 60 && prevDisplayValue < 99 && displayValue > 39 && displayValue < 59) {
    valueContainer.style.animation = 'upper-range-mid-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue >= 60 && prevDisplayValue < 99 && displayValue > 0 && displayValue < 39) {
    valueContainer.style.animation = 'upper-range-lower-range-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue >= 60 && prevDisplayValue < 99 && displayValue == 0) {
    valueContainer.style.animation = 'upper-range-bottom-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  }
  // from mid
  else if (prevDisplayValue >= 40 && prevDisplayValue < 59 && displayValue == 100) {
    valueContainer.style.animation = 'top-mid-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue >= 40 && prevDisplayValue < 59 && displayValue >= 60 && displayValue < 99) {
    valueContainer.style.animation = 'upper-range-mid-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue >= 40 && prevDisplayValue < 59 && displayValue > 0 && displayValue < 39) {
    valueContainer.style.animation = 'mid-lower-range-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue >= 40 && prevDisplayValue < 59 && displayValue == 0) {
    valueContainer.style.animation = 'mid-bottom-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  }
  // from lower range
  else if (prevDisplayValue > 0 && prevDisplayValue < 39 && displayValue == 100) {
    valueContainer.style.animation = 'top-lower-range-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue > 0 && prevDisplayValue < 39 && displayValue >= 60 && displayValue < 99) {
    valueContainer.style.animation = 'upper-range-lower-range-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue > 0 && prevDisplayValue < 39 && displayValue >= 40 && displayValue < 59) {
    valueContainer.style.animation = 'mid-lower-range-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue > 0 && prevDisplayValue < 39 && displayValue == 0) {
    valueContainer.style.animation = 'lower-range-bottom-animation 1s ease-in-out'
    valueContainer.style.animationFillMode = 'forwards'
  }
  // from bottom
  else if (prevDisplayValue == 0 && displayValue == 100) {
    valueContainer.style.animation = 'top-bottom-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue == 0 && displayValue >= 60 && displayValue < 99) {
    valueContainer.style.animation = 'upper-range-bottom-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue == 0 && displayValue >= 40 && displayValue < 59) {
    valueContainer.style.animation = 'mid-bottom-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  } else if (prevDisplayValue == 0 && displayValue > 0 && displayValue < 39) {
    valueContainer.style.animation = 'lower-range-bottom-animation 1s ease-in-out'
    valueContainer.style.animationDirection = 'reverse'
    valueContainer.style.animationFillMode = 'forwards'
  }
  // if the value does not change
  else {
    if (displayValue == 100) {
      valueContainer.style.backgroundPosition = 'center 0%'
    } else if (displayValue >= 60 && prevDisplayValue < 99) {
      valueContainer.style.backgroundPosition = 'center 20%'
    } else if (displayValue >= 40 && prevDisplayValue < 59) {
      valueContainer.style.backgroundPosition = 'center 50%'
    } else if (displayValue > 0 && displayValue < 39) {
      valueContainer.style.backgroundPosition = 'center 85%'
    } else {
      valueContainer.style.backgroundPosition = 'center 100%'
    }
    valueContainer.style.animation = 'all 1s ease-in-out'
  }
}
